// 藥盒上鎖 component

<template lang="pug">
  div
    div.upper-subpanel.row
      progressBar
      div.upper-subpanel--without-progressbar
        div.lockbox-choose-button--wrapper(v-if="stage === 'select'")
          h5.text-center 請選擇欲操作之動作
          hr
          div.choose-buttons
            div.lockbox-choose-button.shadow(@click="selectAction('lock')" id="lock")
              font-awesome-layers.fa-2x.fa-fw
                font-awesome-icon(:icon="arrowDownIcon" transform="shrink-6 up-10")
                font-awesome-icon(:icon="boxOpenIcon" transform="down-1")
              h5(style="margin-left: 10px") 存放藥物
              
            div.lockbox-choose-button.shadow(@click="selectAction('unlock')" id="unlock")
              font-awesome-layers.fa-2x.fa-fw
                font-awesome-icon(:icon="arrowUpIcon" transform="shrink-6 up-10")
                font-awesome-icon(:icon="boxOpenIcon" transform="down-1")
              h5(style="margin-left: 10px") 取出藥物
        div.row.lock-device-position-selection-wrapper(v-if="stage === 'lock'")
          div.col-6
            PositionSelection(mode="lockDevice")
          div.col-6.with-child-centered
            h5 請於左側選擇未使用之保管藥盒
        div(v-if="stage === 'unlock'")
          div.password-wrap
            h5.text-center 請輸入開鎖密碼
            form.input-group(@submit.prevent="confirmPassword")
              div.input-group-prepend
                span.input-group-text 密碼
              input.form-control.mr-2(v-model="password" type="password")
              button.btn.btn-primary(@clickt="confirmPassword") 確認
        div(v-if="stage === 'selectLockedBox'" style="height: 100%")
          div.locked-filled-devices-list(v-if="Object.keys(lockedAndFilledDevices).length > 0")
            div.locked-filled-device(v-for="dev, num in lockedAndFilledDevices" :class="{ 'shadow': dev.selected, 'lock-selected': dev.selected }" @click="selectDevice(num)")
              span 第{{ dev.net.system.open_times}}藥櫃 - 第{{dev.net.row_id}}層 - 第{{dev.pos_row }}列 - 第{{ dev.relative_col }}行
          div.with-child-centered(v-else) 
            h5 未有已使用之藥盒

        div(v-if="stage === 'startFlow'")
          MultiFlow(v-on:setAllConfirmData="getAllConfirmData" :actionType="actionType")
        Loader(v-if="stage === 'loader'")
    BottomButtons
      action-button(title="回主畫面" slot="button-1" @click.native="cancel" id="cancel")
      action-button(title="選擇全部" slot="button-8" @click.native="selectAllDevices" v-if="stage === 'selectLockedBox'")
      action-button(title="開始動作" slot="button-9" @click.native="startflow" id="startflow" :clickable="selectedDevicesID.length > 0")


</template>

<script>
/* This app is not implmented with AppBase structure. */

import Vue from 'vue';
import _ from 'lodash';
import { faArrowDown, faArrowUp, faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import progressBar from './flowComp/ProgressBar';
import BottomButtons from './common/BottomButtons';
import PositionSelection from './flowComp/PositionSelection';
import MultiFlow from './LockBoxFlow/MultiFlow';
import Loader from './common/Loader';

export default {
  name: 'LockBox',
  components: {
    progressBar,
    BottomButtons,
    PositionSelection,
    MultiFlow,
    Loader,
  },
  data() {
    return {
      stage: 'select',
      password: '',
      actionType: '',
      progress: [
        {
          en: 'selectDrug',
          zh: '選擇動作',
        },
        {
          en: 'selectPosition',
          zh: '選擇位置',
        },
        {
          en: 'action',
          zh: '進行動作',
        },
      ],
    };
  },
  created() {
  },
  mounted() {
    this.$store.commit('SET_APP', '藥物保管箱');
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    this.$store.commit('SET_PROGRESS', this.progress);
  },
  computed: {
    allDevices() {
      return this.$store.getters.allDevices;
    },
    selectedDevices() {
      return this.$store.state.device.selectedDevices;
    },
    selectedDevicesID() {
      return this.$store.state.device.selectedDevicesID;
    },
    arrowDownIcon() {
      return faArrowDown;
    },
    arrowUpIcon() {
      return faArrowUp;
    },
    boxOpenIcon() {
      return faBoxOpen;
    },
    lockedAndFilledDevices() {
      const results = {};
      const devs = _.sortBy(Object.values(this.allDevices), ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
      const targetDevices = _.filter(devs, (o) => { return o.specific_type === 'lock_device' && o.drugstorage_set.length > 0; });
      targetDevices.forEach((dev) => {
        // dev.selected = false;
        results[dev.id] = dev;
      });
      return results;
    },
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'Main' });
    },
    startflow() {
      this.stage = 'startFlow';
    },
    selectAction(val) {
      this.stage = val;
      this.actionType = val;
      this.$store.commit('SET_CURRENT_STEP', 'selectPosition');
    },
    async getAllConfirmData() {
      // this.stage = 'loader';
      // this.$store.commit('RESET_DEVICES_MODULE');
      // await this.$store.dispatch('getSystemInfo');
      // this.stage = 'select';
      this.$router.push({ name: 'Main' });
    },
    confirmPassword() {
      if (this.password === '1234') {
        this.stage = 'selectLockedBox';
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '密碼錯誤',
        });
      }
    },
    getLockedAndFilledDevice() {
      const results = {};
      const devs = _.sortBy(Object.values(this.allDevices), ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
      const targetDevices = _.filter(devs, (o) => { return o.specific_type === 'lock_device' && o.drugstorage_set.length > 0; });
      targetDevices.forEach((dev) => {
        dev.selected = false;
        results[dev.id] = dev;
      });
      console.log('set ');
      this.lockedAndFilledDevices = Object.assign({}, results); // array must be registed into data, then vue can detect the changes.
      // this.$set(this, 'lockedAndFilledDevices', results);
    },
    selectDevice(index) {
      this.$store.commit('ADD_DEVICE_TO_SELECTED_LIST', this.lockedAndFilledDevices[index].id);
    },
    selectAllDevices() {
      Object.keys(this.lockedAndFilledDevices).forEach((id) => {
        this.$store.commit('ADD_DEVICE_TO_SELECTED_LIST', id);
      });
    },
  },
};
</script>

<style lang="sass">
$button-size: 150px

.lockbox-choose-button--wrapper
  display: flex
  justify-content: center
  flex-direction: column
  height: 100%
  align-items: center
  .choose-buttons
    display: flex;
    width: 600px;
    justify-content: space-around;

  .lockbox-choose-button 
    width: $button-size + 80px 
    height: $button-size 
    display: flex
    align-items: center
    justify-content: center
    background-color: steelblue
    color: white
    border-radius: 15px

.lock-device-position-selection-wrapper
  height: 100%

.password-wrap
  padding: 20%;
  

.locked-filled-device
  padding: 10px;
  margin: 10px;
  border: 1px solid orange;
  text-align: center
  
  span
    color: black
    background: white
    padding: 5px 20px
  &.lock-selected
    background: repeating-linear-gradient(-45deg, orange, orange 10px, transparent 10px, transparent 20px) !important;
    
</style>



// WEBPACK FOOTER //
// LockBox.vue?490de8bd